var _defs, _g, _style;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(241, 242, 243, 0)",
      display: "block",
      zIndex: 1,
      position: "relative",
      shapeRendering: "auto"
    },
    width: 1828,
    height: 1263,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1440 762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "p1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M 1328.262725233854 514.3221957937322 c 0 20.017816231864945 -4.89797631205206 5.7497982793654625 -10.647774591417523 5.7497982793654625 S 1306.967176051019 534.3400120255972 1306.967176051019 514.3221957937322 s 4.89797631205206 -5.7497982793654625 10.647774591417523 -5.7497982793654625 S 1328.262725233854 494.3043795618673 1328.262725233854 514.3221957937322 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6.636207709795123,
    fill: "#3761F9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-5.402655890077561s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M 1126.1462662015124 334.60024152726794 c 0 30.58252974993728 -7.482959406899546 8.78434365157773 -16.267303058477275 8.78434365157773 S 1093.611660084558 365.18277127720523 1093.611660084558 334.60024152726794 s 7.482959406899546 -8.78434365157773 16.267303058477275 -8.78434365157773 S 1126.1462662015124 304.01771177733065 1126.1462662015124 334.60024152726794 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.8866954919899435,
    fill: "#805ad5"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-0.7469029840989255s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M 1161.7504435660335 640.6428888832513 c 0 31.719898409595036 -7.761251738517934 9.111034649564532 -16.872286388082465 9.111034649564532 S 1128.0058707898684 672.3627872928464 1128.0058707898684 640.6428888832513 s 7.761251738517934 -9.111034649564532 16.872286388082465 -9.111034649564532 S 1161.7504435660335 608.9229904736562 1161.7504435660335 640.6428888832513 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4.620989905120926,
    fill: "#d53f8c"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-0.1511828641728111s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M 741.9260757987616 120.55457487293772 c 0 22.360654120299248 -5.471223880498751 6.422741077107231 -11.893964957605982 6.422741077107231 S 718.1381458835498 142.91522899323698 718.1381458835498 120.55457487293772 s 5.471223880498751 -6.422741077107231 11.893964957605982 -6.422741077107231 S 741.9260757987616 98.19392075263848 741.9260757987616 120.55457487293772 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.644208965350321,
    fill: "#0bc5ea"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-7.82610169106669s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M 831.5629886202872 388.48756509181925 c 0 37.036017955096774 -9.062004393268358 10.638005157315032 -19.700009550583392 10.638005157315032 S 792.1629695191203 425.52358304691603 792.1629695191203 388.48756509181925 s 9.062004393268358 -10.638005157315032 19.700009550583392 -10.638005157315032 S 831.5629886202872 351.45154713672247 831.5629886202872 388.48756509181925 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6.245518484932514,
    fill: "#0bc5ea"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-2.5196369079325094s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M 212.88893404527536 420.47807924073214 c 0 36.54095420882101 -8.940871774498756 10.495805996150716 -19.436677770649474 10.495805996150716 S 174.0155785039764 457.01903344955315 174.0155785039764 420.47807924073214 s 8.940871774498756 -10.495805996150716 19.436677770649474 -10.495805996150716 S 212.88893404527536 383.93712503191114 212.88893404527536 420.47807924073214 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.849223811801136,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-6.684622598095676s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M 1324.9457560414432 238.47197515867774 c 0 30.80275218576268 -7.536843619920655 8.84759903208077 -16.384442652001425 8.84759903208077 S 1292.1768707374406 269.2747273444404 1292.1768707374406 238.47197515867774 s 7.536843619920655 -8.84759903208077 16.384442652001425 -8.84759903208077 S 1324.9457560414432 207.66922297291507 1324.9457560414432 238.47197515867774 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4.343761268348013,
    fill: "#d53f8c"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-2.7335074334729264s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path6"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M 684.9617171054817 510.78873702528506 c 0 25.338697068736554 -6.199893963627028 7.278136392083904 -13.478030355710933 7.278136392083904 S 658.0056563940598 536.1274340940216 658.0056563940598 510.78873702528506 s 6.199893963627028 -7.278136392083904 13.478030355710933 -7.278136392083904 S 684.9617171054817 485.4500399565485 684.9617171054817 510.78873702528506 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.289313753392392,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-7.543609599938508s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M 242.9059981525392 78.17885685832343 c 0 23.178973635392506 -5.6714509958939106 6.657790299527634 -12.329241295421545 6.657790299527634 S 218.2475155616961 101.35783049371594 218.2475155616961 78.17885685832343 s 5.6714509958939106 -6.657790299527634 12.329241295421545 -6.657790299527634 S 242.9059981525392 54.99988322293092 242.9059981525392 78.17885685832343 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4.596220485664493,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-4.340748007737184s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M 348.3092125752333 541.3878064308448 c 0 22.224503222827753 -5.437910363032322 6.3836339044292485 -11.82154426746157 6.3836339044292485 S 324.6661240403102 563.6123096536725 324.6661240403102 541.3878064308448 s 5.437910363032322 -6.3836339044292485 11.82154426746157 -6.3836339044292485 S 348.3092125752333 519.163303208017 348.3092125752333 541.3878064308448 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.238035639347363,
    fill: "#0bc5ea"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-8.467966102200643s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M 121.0397728376659 134.18105370502505 c 0 20.069120684009604 -4.91052952906618 5.764534664555951 -10.67506419362213 5.764534664555951 S 99.68964445042162 154.25017438903467 99.68964445042162 134.18105370502505 s 4.91052952906618 -5.764534664555951 10.67506419362213 -5.764534664555951 S 121.0397728376659 114.11193302101545 121.0397728376659 134.18105370502505 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6.983493658697949,
    fill: "#00cd98"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-2.9429563736891633s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path10"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M 756.7860327276691 650.6485600880425 c 0 34.39061233935505 -8.414724295799639 9.87815460811262 -18.29287890391226 9.87815460811262 S 720.2002749198444 685.0391724273975 720.2002749198444 650.6485600880425 s 8.414724295799639 -9.87815460811262 18.29287890391226 -9.87815460811262 S 756.7860327276691 616.2579477486875 756.7860327276691 650.6485600880425 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.540837914078185,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-7.088397398976333s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path11"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M 365.57927615149157 277.7571015725914 c 0 23.94448418286143 -5.858756768146946 6.877670988694241 -12.736427756841186 6.877670988694241 S 340.1064206378092 301.7015857554528 340.1064206378092 277.7571015725914 s 5.858756768146946 -6.877670988694241 12.736427756841186 -6.877670988694241 S 365.57927615149157 253.81261738972998 365.57927615149157 277.7571015725914 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6.407931781878242,
    fill: "#d53f8c"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-2.682043751732108s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path12"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M 972.7911220358908 121.76273221677724 c 0 26.551922715265047 -6.496747047352085 7.626616099065493 -14.123363146417578 7.626616099065493 S 944.5443957430557 148.3146549320423 944.5443957430557 121.76273221677724 s 6.496747047352085 -7.626616099065493 14.123363146417578 -7.626616099065493 S 972.7911220358908 95.21080950151219 972.7911220358908 121.76273221677724 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4.027870690186804,
    fill: "#0bc5ea"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-2.649503058039237s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path13"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M 1430.8501439583986 504.85980259202046 c 0 27.37597929983105 -6.698377913788448 7.863313203142962 -14.56169111693141 7.863313203142962 S 1401.726761724536 532.2357818918515 1401.726761724536 504.85980259202046 s 6.698377913788448 -7.863313203142962 14.56169111693141 -7.863313203142962 S 1430.8501439583986 477.4838232921894 1430.8501439583986 504.85980259202046 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.199444995509243,
    fill: "#805ad5"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-2.6460857467576675s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path14"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M 311.7319321508727 748.2881185026815 c 0 36.73015631275312 -8.987165906311931 10.550151281322703 -19.537317187634635 10.550151281322703 S 272.6572977756034 785.0182748154347 272.6572977756034 748.2881185026815 s 8.987165906311931 -10.550151281322703 19.537317187634635 -10.550151281322703 S 311.7319321508727 711.5579621899284 311.7319321508727 748.2881185026815 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6.833135551165933,
    fill: "#805ad5"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-3.477025199384847s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path15"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 27.931230557396546 398.8170778136326 c 0 36.484581709751005 -8.927078503449712 10.479613895354012 -19.406692398803724 10.479613895354012 S -10.882154240210903 435.3016595233836 -10.882154240210903 398.8170778136326 s 8.927078503449712 -10.479613895354012 19.406692398803724 -10.479613895354012 S 27.931230557396546 362.33249610388157 27.931230557396546 398.8170778136326 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6.751673502370236,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-4.651151174062854s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path16"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M 272.28166902595126 667.968121944589 c 0 27.205157170761243 -6.656581009867112 7.814247272452698 -14.47082828231981 7.814247272452698 S 243.34001246131163 695.1732791153503 243.34001246131163 667.968121944589 s 6.656581009867112 -7.814247272452698 14.47082828231981 -7.814247272452698 S 272.28166902595126 640.7629647738278 272.28166902595126 667.968121944589 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.3606188966557,
    fill: "#00cd98"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-7.04658471291239s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path17"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 68.52816055717062 509.72412109826104 c 0 29.887169878152417 -7.31281816167559 8.584612624575694 -15.897430786251284 8.584612624575694 S 36.73329898466806 539.6112909764134 36.73329898466806 509.72412109826104 s 7.31281816167559 -8.584612624575694 15.897430786251284 -8.584612624575694 S 68.52816055717062 479.83695122010863 68.52816055717062 509.72412109826104 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4.766600847571331,
    fill: "#d53f8c"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-2.943182568910145s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path18"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M 498.4867256914234 698.0428393714164 c 0 30.16800088761881 -7.381532132076942 8.66527685069902 -16.04680898277596 8.66527685069902 S 466.3931077258714 728.2108402590353 466.3931077258714 698.0428393714164 s 7.381532132076942 -8.66527685069902 16.04680898277596 -8.66527685069902 S 498.4867256914234 667.8748384837976 498.4867256914234 698.0428393714164 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4.890716067451898,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-6.922790379009164s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path19"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M 237.31670847162988 570.9916865103482 c 0 37.44732484185728 -9.162643312369333 10.756146497129219 -19.918789809498552 10.756146497129219 S 197.47912885263278 608.4390113522055 197.47912885263278 570.9916865103482 s 9.162643312369333 -10.756146497129219 19.918789809498552 -10.756146497129219 S 237.31670847162988 533.544361668491 237.31670847162988 570.9916865103482 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5.209445859656978,
    fill: "#0bc5ea"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-2.7842860998444956s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path20"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M 844.5838314420802 300.2789933084955 c 0 34.33444958544051 -8.400982345373741 9.862022753264826 -18.263005098638565 9.862022753264826 S 808.057821244803 334.613442893936 808.057821244803 300.2789933084955 s 8.400982345373741 -9.862022753264826 18.263005098638565 -9.862022753264826 S 844.5838314420802 265.944543723055 844.5838314420802 300.2789933084955 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.131681051998438,
    fill: "#d53f8c"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-7.648757144503393s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path21"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M 421.60153544835583 277.80813669372634 c 0 28.261187796624853 -6.914971482152889 8.117575218179478 -15.032546700332368 8.117575218179478 S 391.5364420476911 306.06932449035116 391.5364420476911 277.80813669372634 s 6.914971482152889 -8.117575218179478 15.032546700332368 -8.117575218179478 S 421.60153544835583 249.5469488971015 421.60153544835583 277.80813669372634 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6.2646621562845475,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-2.810604110269037s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path22"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "M 964.8180299061758 251.70205930626756 c 0 20.201912557872895 -4.94302115777741 5.802677011303916 -10.745698169081326 5.802677011303916 S 943.326633568013 271.90397186414043 943.326633568013 251.70205930626756 s 4.94302115777741 -5.802677011303916 10.745698169081326 -5.802677011303916 S 964.8180299061758 231.50014674839466 964.8180299061758 251.70205930626756 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.739792304581866,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-1.283147684069228s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path23"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M 450.56452845180536 467.20670088348527 c 0 32.652475993971414 -7.9894356155461965 9.378902679119449 -17.368338294665648 9.378902679119449 S 415.82785186247406 499.85917687745666 415.82785186247406 467.20670088348527 s 7.9894356155461965 -9.378902679119449 17.368338294665648 -9.378902679119449 S 450.56452845180536 434.5542248895139 450.56452845180536 467.20670088348527 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4.206016322416145,
    fill: "#d53f8c"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-7.04290071253574s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path24"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "M 470.9609539413972 631.8555550663143 c 0 28.374834580757934 -6.942778674015238 8.150218443409194 -15.092997117424432 8.150218443409194 S 440.7749597065483 660.2303896470722 440.7749597065483 631.8555550663143 s 6.942778674015238 -8.150218443409194 15.092997117424432 -8.150218443409194 S 470.9609539413972 603.4807204855564 470.9609539413972 631.8555550663143 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4.877171471279329,
    fill: "#0bc5ea"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-8.585901919755338s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path25"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M 652.7362252048207 288.7979351349304 c 0 35.42106100309088 -8.666855351820105 10.174134543440996 -18.840989895261103 10.174134543440996 S 615.0542454142984 324.2189961380213 615.0542454142984 288.7979351349304 s 8.666855351820105 -10.174134543440996 18.840989895261103 -10.174134543440996 S 652.7362252048207 253.37687413183954 652.7362252048207 288.7979351349304 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.352056724470119,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-3.198081211934429s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path26"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M 688.3012291378494 41.23417469454655 c 0 28.909045473514027 -7.0734898499023675 8.303661997711476 -15.377151847613844 8.303661997711476 S 657.5469254426217 70.14322016806058 657.5469254426217 41.23417469454655 s 7.0734898499023675 -8.303661997711476 15.377151847613844 -8.303661997711476 S 688.3012291378494 12.325129221032526 688.3012291378494 41.23417469454655 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7.293346109382834,
    fill: "#0bc5ea"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-3.635270207745576s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path27"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M 1061.2362270938456 195.39666378859346 c 0 19.39566461418629 -4.74574772474771 5.571095155138616 -10.316842879886325 5.571095155138616 S 1040.602541334073 214.79232840277976 1040.602541334073 195.39666378859346 s 4.74574772474771 -5.571095155138616 10.316842879886325 -5.571095155138616 S 1061.2362270938456 176.00099917440716 1061.2362270938456 195.39666378859346 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5.040205474760767,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-7.665407360938512s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path28"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "M 824.7580606207787 636.1887703563605 c 0 32.85378799118968 -8.03869280635492 9.436726337894909 -17.475419144249827 9.436726337894909 S 789.807222332279 669.0425583475501 789.807222332279 636.1887703563605 s 8.03869280635492 -9.436726337894909 17.475419144249827 -9.436726337894909 S 824.7580606207787 603.3349823651708 824.7580606207787 636.1887703563605 z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4.76580996967193,
    fill: "#3761f9"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "-8.946715083233848s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#path29"
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".lded > .content, .lded > .content > .inner { height: 100%; }\n.lded > .content > .inner > .viewer { width: 100%; height: 100%; max-width: 100%; overflow: hidden }\n.lded > .content > .inner > .panel {\n  position: absolute;\n  bottom: 50px;\n  left: 0;\n  right: 0;\n  opacity: 0.3;\n}\n.lded > .content > .inner > .panel:hover { opacity: 1; }\n.lded > .content > .inner > .ctrl {\n  position: absolute;\n  bottom: 13px;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n.lded > .content > .inner > .ctrl:hover {\n  z-index: 10;\n}\n#editor > .inner > .title {\n  position: absolute;\n  bottom: 195px;\n  left: 0;\n  right: 0;\n  z-index: 11;\n}\n#editor > .inner > .title > a:first-child {\n  margin-left: 0!important;\n#editor .lded .viewer { border-radius: 0 }")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbs);
export default __webpack_public_path__ + "static/media/orbs.ebca3d8c20ccf699135a7c0561a462f2.svg";
export { ForwardRef as ReactComponent };